// Because vendor.js is going to export us as "jquery" for all.js, we can't
// just require('jquery') here, because that will try to require ourself.
const $ = require('jquery/dist/jquery.js');
const { featureFlagClient } = require('@trello/feature-flag-client');

// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
// remove this patch when project is upgraded to jQuery 3.x
$.ajaxPrefilter((s) => {
  if (s.crossDomain) {
    s.contents.script = false;
  }
});

window.jQuery = $;
window.$ = $;
if (featureFlagClient.get('fep.jquery-ui-1.13', false)) {
  // jQuery-ui 1.13.1
  require('../vendor/jquery.ui/widget.js');
  require('../vendor/jquery.ui/widgets/mouse.js');
  require('../vendor/jquery.ui/core.js');
  require('../vendor/jquery.ui/position.js');
  require('../vendor/jquery.ui/widgets/draggable.js');
  require('../vendor/jquery.ui/widgets/droppable.js');
  require('../vendor/jquery.ui/widgets/sortable.js');
} else {
  // jQuery-ui 1.10.3
  require('../vendor/jquery.ui.core.js');
  require('../vendor/jquery.ui.widget.js');
  require('../vendor/jquery.ui.mouse.js');
  require('../vendor/jquery.ui.position.js');
  require('../vendor/jquery.ui.draggable.js');
  require('../vendor/jquery.ui.droppable.js');
  require('../vendor/jquery.ui.sortable.js');
}
require('../vendor/jquery.cookie.js');
require('../vendor/jquery.crop.js');
require('../vendor/jquery.mousewheel.js');
require('../vendor/jquery.autosize.js');
require('../vendor/jquery.dragscrollable.js');

// Apparently those stupid files don't close over the jQuery variable.
// So we can't delete it after we're done.
// delete window.jQuery;
// delete window.$;

module.exports = $;
